import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { first, map, takeUntil } from 'rxjs/operators';
import { InformationComponent } from '../../../shared/modals/information/information.component';
import { PreferenceMessages } from '../../../shared/models/component-messages/preference-messages';
import { PreferenceAcheteurEnum, PreferenceAcheteurPrincipal } from '../model/preference-acheteur-principal';
import { PreferencesService } from '../services/preferences.service';
import { EnumMicroDroits } from '../../../administration/models/micro.droits';
import { AuthorizationService } from '../../../../authorization/services/authorization.service';

@Component({
  selector: 'app-preferences-acheteur-principal',
  templateUrl: './preferences-acheteur-principal.component.html',
  styleUrls: ['./preferences-acheteur-principal.component.scss']
})
export class PreferencesAcheteurPrincipalComponent {

  public preferenceMessages = new PreferenceMessages();

  private unsubscribe$ = new Subject<void>();

  acheteurPrincipalTableau: PreferenceAcheteurPrincipal[] = [];

  isGestionComptesAnnonceur: boolean;

  constructor(private preferenceService: PreferencesService, private modalService: NgbModal, private router: Router,
    private titleService: Title, private authorizationService: AuthorizationService) { }

  ngOnInit(): void {
    this.getPref();
    this.titleService.setTitle('Avis de publicité - Préférences');
    this.habilitations();
  }

  createList(): void {
    this.router.navigate([location.pathname + '/pref-acheteur-principal']);
  }

  getPref(): void {
    this.preferenceService.getFullAcheteur().pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: ((data) => {
          this.acheteurPrincipalTableau = [];
          data.forEach(el => {
            const acheteur = new PreferenceAcheteurPrincipal();
            acheteur.id = el.id;
            acheteur.titre = el.titre;
            acheteur.dateCreation = el.dateCreation;

            for (let value in el.content.values) {
              switch (el.content.values[value].code) {
                case PreferenceAcheteurEnum.PERSONNE_PHYSIQUE:
                  if (el.content.values[value].value === 'true')
                    acheteur.personnePhysique = true;
                  else if (el.content.values[value].value === 'false')
                    acheteur.personnePhysique = false;
                  break;
                case PreferenceAcheteurEnum.NOM_OFFICIEL:
                  acheteur.nomOfficiel = el.content.values[value].value;
                  break;
                case PreferenceAcheteurEnum.NUM_ENREGISTREMENT:
                  acheteur.numEnregistrement = el.content.values[value].value;
                  break;
                case PreferenceAcheteurEnum.DEPARTEMENT:
                  acheteur.departement = el.content.values[value].value;
                  break;

                default:
                  break;
              }
            }

            this.acheteurPrincipalTableau?.push(acheteur);
          })
        })
      });
  }

  update(item: PreferenceAcheteurPrincipal): void {
    this.router.navigate([location.pathname + '/pref-acheteur-principal/' + item.id]);
  }

  delete(item: PreferenceAcheteurPrincipal): void {

    const modalRef = this.modalService.open(InformationComponent);
    modalRef.componentInstance.title = '';
    modalRef.componentInstance.content = this.preferenceMessages.modal_delete_text;
    modalRef.componentInstance.OkOuRetour = true;
    modalRef.dismissed.pipe(map((reason: boolean) => {
      return reason;
    }))
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: ((reason) => {
          if (reason) {
            this.preferenceService.deleteAcheteur(item.id)
              .pipe(takeUntil(this.unsubscribe$))
              .subscribe({
                next: (() => {
                  this.getPref();
                })
              });
          }
        })
      })
  }

  shiftBoolean(bool: boolean): string {
    let retour: string = null;
    if (bool)
      retour = 'oui';
    else if (bool === false)
      retour = 'non'
    return retour;
  }

  get sortAcheteur() {
    return this.acheteurPrincipalTableau.sort((a, b) => {
      return <any>new Date(b.dateCreation) - <any>new Date(a.dateCreation);
    });
  }

  private habilitations() {
    this.authorizationService.hasAnyMicroRightIn([EnumMicroDroits.COMPTES_ANNONCEURS_GESTION])
      .pipe(first())
      .subscribe(isGestionComptesAnnonceur => { this.isGestionComptesAnnonceur = isGestionComptesAnnonceur });
  }

}
